import { postReturnService, retailerSettingsService, returnItemsService } from '../../services';

export const getWarehouseAddress = () => {
  const settings = retailerSettingsService.getSettings();
  const settingsMethods = settings.return_methods || [];
  const methodName = returnItemsService.getMethod();
  let warehouseAddress;

  settingsMethods.forEach((returnMethod) => {
    if (returnMethod.return_method === methodName && returnMethod.display_warehouse_address) {
      warehouseAddress = postReturnService.getReturn().return_address;
    }
  });


  return warehouseAddress;
};
